export class GiftCardOrderSalesModel{
    ID_ORDER_SALES: number;
    ID_MODELO_GIFT_CARD: number;
    DESC_MODELO_GIFT_CARD: string;
    IMG_MODELO_GIFT_CARD: string;
    ID_CLIENTE: number;
    ID_JOB: number;
    BEGIN_NUMBER: number;
    BEGIN_SECUENCE: number;
    ID_ASSIGN_NCR: number;
    ID_DISTR_NCR: number;
    NRORUC_CLIENTE: string;
    RAZSOC_CLIENTE: string;
    ID_CONTACT: number;
    NOMBRE_CONTACTO: string;
    CORREO_CONTACTO: string;
    NRO_ORDEN_COMPRA: string;
    IMG_ORDEN_COMPRA: string;
    IMG_COTIZACION: string;
    IMG_ADICIONAL1: string;
    IMG_ADICIONAL2: string;
    IMG_ADICIONAL3: string;
    ID_FILE_LIQUI: number;
    IMG_LIQUIDACION: string;
    ID_FILE_CONST: number;
    IMG_CONSTANCIA: string;
    ID_FILE_GUIA: number;
    IMG_GUIA: string;
    IMP_ORDEN_COMPRA: number; 
    CAN_ORDEN_COMPRA: number;
    FEC_INI_VIGENCIA: string;
    FEC_FIN_VIGENCIA: string;
    ID_TEMPLATE: number;
    OBSERVACIONES: string;
    CREATIONUSER: string;
    CREATIONDATE: string;
    FLG_ACTIVO: number;
    EMAILFAILS: number;
    EMAILSEND: number;
    EMAILOK: number;
    PERMANENCIA: number;
    ESTADO: string;
    ACCION: string;
    ID_TYPE_NCR: number;
  }

  export class GiftCardVirtualsModel{
    ID_GIFT_CARD: number;
    ID_ORDER_GIFT_CARD: number;
    ID_MODELO_GIFT_CARD: number;
    NUMALE_GIFT_CARD: number;
    PREFIX_GIFT_CARD: string;
    CODIGO_GIFT_CARD: string;
    BIN_GIFT_CARD: string;
    ID_GROUP: number;
    ID_SECUENCE_NCR: number;
    NOMBR_GIFT_CARD: string;
    MONTO_GIFT_CARD: number;
    DOCUM_GIFT_CARD: string;
    TEXTO_GIFT_CARD: string;
    EMAIL_GIFT_CARD: string; 
    VALID_TEXT_GIFT_CARD: string;
    STATUS_ENVIO: string;
  }

  export class GiftCardVirtualsModelNCR{
    giftcard: number;
    secuencial: number;
    CVV: number;
  }

  export class PlantillaNCR{
    GIFTCARD: number;
    SECUENCIAL: number;
  }

  export class GiftCardGroupModel{
    ID_GROUP: number;
		ID_ORDER_GIFT_CARD: number;
    ID_MODELO_GIFT_CARD: number;
		ID_CLIENTE: number;
		ID_CONTACT: number;
		IMP_ORDER_GIFT_CARD: number;
		CAN_ORDER_GIFT_CARD: number;
		NRO_GROUP: number;
		IMP_GROUP: number;
		CAN_GROUP: number;
  }

  export class GiftCardClientsModel{
    ID_CLIENTE: number;
    NRORUC_CLIENTE: string;
    RAZSOC_CLIENTE: string;    
    CREATIONUSER: string;
    CREATIONDATE: string;
    FLG_ACTIVO: number;
  }

  export class GiftCardContactModel{
    ID_CONTACT: number;
    ID_CLIENTE: number;
    NOMBRE_CONTACTO: string;
    CORREO_CONTACTO: string;   
    CREATIONUSER: string;
    CREATIONDATE: string;
    FLG_ACTIVO: number;
    ESTADO: string;
  }

  export class GiftCardTypesModel{
    id: number;
    code: number;
    name: string;
    useType: string;
    creationDate: string;
    minAmount: number;
    maxAmount: number;
    active: number;
    activationType: string;
  }

  export class GiftCardNCRModel{
    id: number;
    number: number;
    sequence: number;
    status: string;
    statusModificationDate: string;
    branchId: number;
    netAmount: number;
    assignationBatch: number;
    assignationBatchIdx: number;
    distributionBatch: number;
    distributionBatchIdx: number;
  }

  export class GiftCardModel{
    ID_TYPES: number;
    ID_TYPES_NCR: number;
    DESC_TYPES: string;
    TYPE_MODEL: string;
    TYPE_MODEL_DESC: string;
    CREATIONUSER: string;
    CREATIONDATE: string;
    FLG_ACTIVO: number;
    ESTADO: string;
  }

  export class GiftCardTiendaItemModel{
    ID_ORDER_SALES: number;
    ID_CLIENTE: number;
    ID_CONTACT: number;
    SKU: number;
    DESCRIPCION: string;
    CANTIDAD: number;
    PRECIOCIGV: number;
    PRECIOSIGV: number;
    SUBTOTAL: number;
    CREATIONUSER: string;
    CREATIONDATE: string;
    FLG_ACTIVO: number;
  }

